import Skeleton from 'react-loading-skeleton'
import { useCompanyInfo } from '../../../../Providers/CompanyInfoProvider'
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa6";
import { useAuth } from '../../../../Providers/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { useShop } from '../../../../Providers/ShopProvider';
import { useLastWatchedProducts } from '../../../../Providers/LastWatchedProductsProvider';
import { ConvertPriceToString } from '../../../../Helpers/CustomConverter';
import { toast } from 'react-toastify';
import { CiBellOn } from "react-icons/ci";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { useEffect, useRef, useState } from 'react';
import { useOffers } from '../../../../Providers/OffersProvider';
import { GoPeople } from "react-icons/go";
import { useCustomer } from '../../../../Providers/CustomerProvider';
import { useSavedBaskets } from '../../../../Providers/SavedBasketsProvider';
import { FiShoppingCart } from "react-icons/fi";
import { MdOutlineLocalOffer } from "react-icons/md";
import { TbShoppingCartPlus } from "react-icons/tb";

/**
 * DK : Hook dla wspólnych funkcji dla komponentów mobilnych oraz desktopowych.
 */
const useCommonFunctions = () => {
    const { companyInfoData } = useCompanyInfo()
    const { authState, changeSelectedCustomer } = useAuth()
    const { setActiveCategory, setProductsFilter } = useShop()
    const navigate = useNavigate()
    const { addProductToLastWatched } = useLastWatchedProducts()
    const { setEditOfferRequestOfferNo, editOfferRequestOfferNo, savedOfferId } = useOffers()
    const { setSelectedSavedBasket, selectedSavedBasket } = useSavedBaskets()

    const getLoadingDataSkeleton = (isMobile) => {
        const skeletonStyle = isMobile ? 'ms-3 mt-3 mb-3' : 'ms-3'
        return (<>
            <Skeleton className={skeletonStyle} height={20} width={200} highlightColor="white" baseColor='#cccaca' />
            <Skeleton className={skeletonStyle} height={20} width={200} highlightColor="white" baseColor='#cccaca' />
            <Skeleton className={skeletonStyle} height={20} width={200} highlightColor="white" baseColor='#cccaca' />
            <Skeleton className={skeletonStyle} height={20} width={200} highlightColor="white" baseColor='#cccaca' />
            <Skeleton className={skeletonStyle} height={20} width={200} highlightColor="white" baseColor='#cccaca' />
        </>)
    }

    const getSocialMediaIcons = (handleReDirect, isMobile) => {
        const size = isMobile ? 28 : 20
        const facebook = companyInfoData.facebook ? <FaFacebookF size={size} color='white' cursor={'pointer'} onClick={() => handleReDirect(companyInfoData.facebook, false)} /> : null
        const instagram = companyInfoData.instagram ? <FaInstagram size={size} color='white' cursor={'pointer'} onClick={() => handleReDirect(companyInfoData.instagram, false)} /> : null
        const youtube = companyInfoData.youtube ? <FaYoutube size={size} color='white' cursor={'pointer'} onClick={() => handleReDirect(companyInfoData.youtube, false)} /> : null
        const linkedin = companyInfoData.linkedIn ? <FaLinkedinIn size={size} color='white' cursor={'pointer'} onClick={() => handleReDirect(companyInfoData.linkedIn, false)} /> : null
        return (<>
            {facebook}
            {instagram}
            {youtube}
            {linkedin}
        </>)
    }

    /**
    *  DK : Zwraca dane zalogowanego użytkownika oraz wybrana firme
    */
    const generateUserInformation = (isMobile) => {
        let userInfo = ''
        if (!isMobile && !authState.user) {
            return <span>Moje konto</span>
        }
        if (isMobile && !authState.user) {
            return null
        }
        if (authState.user && authState.user.email) {
            userInfo = authState.user.email.replace(/\s+/g, '').length > 0 ? authState.user.email : authState.user.userId
        }
        else {
            userInfo = authState.user.userId
        }
        let company = authState.selectedCustomer ? authState.selectedCustomer : (authState.user.customerInfo ? authState.user.customerInfo[0].name : '')
        let showSeparatorStyle = company ? 'users-separator' : 'collapse'
        if (isMobile) {
            return (<>
                <span>{userInfo}</span>
                <div className='ms-2 me-2' />
                <div className={`col-12  ${showSeparatorStyle}`} />
                <span>{company}</span>
            </>)
        }
        else {
            return (<div className="d-flex flex-column align-items-center">
                <span>{userInfo}</span>
                <div className='ms-2 me-2' />
                <div className={`col-12  ${showSeparatorStyle}`} />
                <span>{company}</span>
            </div>)
        }

    }

    const handleCategoryClick = (category, query, setIsFocus = null) => {
        setActiveCategory(category)
        if (setIsFocus) {
            setIsFocus(false)
        }
        navigate(`/Shop?q=${query}`)
    }

    const handleSupplierClick = (supplier, query, setIsFocus = null) => {
        setProductsFilter(prev => ({
            ...prev,
            ProductsFeatures: [],
            ActiveCatNodeId: 0,
            ArtNo: '',
            Suppliers: [{ supplierId: supplier.supplierId, supplierName: supplier.supplierName }],
            SearchingQuery: query,
        }))
        localStorage.setItem("categoryNavigationTree", JSON.stringify(null))
        setActiveCategory(0)
        if (setIsFocus) {
            setIsFocus(false)
        }
        navigate(`/Shop?q=${query}`)
    }

    const handleProductInQueryClick = (index, setIsFocus = null) => {
        if (setIsFocus) {
            setIsFocus(false)
        }
        if (authState.user) {
            addProductToLastWatched(index)
        }
        navigate(`/product/${index}`, { state: { params: { productIndex: index } } })
    }

    const getSumGross = (offerItemsTotalGross, offerItems, cartItems, basketTotalPriceGross) => {
        if (offerItems.length > 0) {
            return ConvertPriceToString(offerItemsTotalGross)
        }
        else {
            return cartItems && cartItems.basketItems && cartItems.basketItems[0] ? <b>{ConvertPriceToString(basketTotalPriceGross, cartItems.basketItems[0].currency)}</b> : ConvertPriceToString(0.00)
        }
    }

    const handleCopyToClipboard = async (text, toastText = "Tekst został skopiowany") => {
        await navigator.clipboard.writeText(text)
        toast.success(toastText)
    }

    const NotificationSection = ({ isMobile }) => {
        const { handleGetNumberOfUnreadCustomerOffer, numberOfUnreadCustomerOffer } = useOffers()
        const [showNotificationDetails, setShowNotificationDetails] = useState(false)

        useEffect(() => {
            //const source = axios.CancelToken.source()

            const fetchNotifications = async () => {
                await handleGetNumberOfUnreadCustomerOffer()
            }

            fetchNotifications()
            const intervalInMilliseconds = 30 * 60 * 1000 //30min
            const intervalId = setInterval(fetchNotifications, intervalInMilliseconds)

            return () => {
                //source.cancel()
                clearInterval(intervalId)
            }
        }, [])

        var offersText = numberOfUnreadCustomerOffer === 1 ? 'nową ofertę. Znajdziesz ją w zakładce Oferty TG' : `nowe oferty w liczbie ${numberOfUnreadCustomerOffer}. Znajdziesz je w zakładce Oferty TG`
        const notificationInformationElementStyle = isMobile ? 'notification-information-element-mobile' : 'notification-information-element'

        return (<div className='element-pointer'>
            <div style={{ position: 'relative' }} onMouseEnter={() => setShowNotificationDetails(true)} onMouseLeave={() => setShowNotificationDetails(false)}>
                <CiBellOn size={25} className='nav-bar-color-primary' />
                {numberOfUnreadCustomerOffer > 0 && <div className='cart-circle-navbar'>
                    1
                </div>}
                {showNotificationDetails && numberOfUnreadCustomerOffer > 0 &&
                    <div className={`${notificationInformationElementStyle} position-absolute`}>
                        <div className="row d-flex align-items-center">
                            <div className="col-auto">
                                <MdOutlineNotificationsActive size={20} color='var(--primary)' />
                            </div>
                            <div className="col">
                                <span onClick={() => navigate('/Offers')} className='notification-information-element-item'>{`TG Instalacje przygotowało dla Ciebie ${offersText}`}</span>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </div>)
    }

    const QuickContractorSelectorSection = ({ isMobile }) => {
        const contractorSectionTimeoutRef = useRef(null)
        const { contractorsWithSavedBasket } = useCustomer()
        const [showContractors, setShowContractors] = useState(false)

        const cancelHideTimeout = () => {
            if (contractorSectionTimeoutRef.current) {
                clearTimeout(contractorSectionTimeoutRef.current)
            }
        }

        const handleContactSectionMouseEnter = () => {
            cancelHideTimeout()
            setShowContractors(true)
        }

        const handleContactSectionMouseLeave = () => {
            contractorSectionTimeoutRef.current = setTimeout(() => {
                setShowContractors(false)
            }, 300)
        }

        const handleCustomerChange = (contractor) => {
            changeSelectedCustomer(contractor.custId, contractor.siteId, contractor.whId, contractor.name, '', contractor.nip, contractor.zipCode, contractor.city, contractor.street,
                contractor.houseNum, contractor.locumNum, contractor.email, contractor.phone, contractor.dpl)
            setProductsFilter(prev => ({
                ...prev,
                SiteId: contractor.siteId ? contractor.siteId : '',
                WhId: contractor.whId ? contractor.whId : '',
            }))
            navigate('/Cart')
        }

        const getLastAddedProductInBasketDate = (value) => {
            if (!value) {
                return ''
            }
            else if (value == '0001-01-01') {
                return ''
            }
            else {
                return value.slice(0, 10)
            }
        }

        let contractorSelectorStyle = isMobile ? 'contractor-selector-mobile' : 'contractor-selector'

        if (authState && authState.user && authState.user.isOperator) {
            return (
                <div className='element-pointer'>
                    <div style={{ position: 'relative' }} onMouseEnter={() => handleContactSectionMouseEnter()} onMouseLeave={() => handleContactSectionMouseLeave()}
                        onClick={() => setShowContractors(prev => !prev)}>
                        <GoPeople size={25} className='nav-bar-color-primary' />
                        {contractorsWithSavedBasket && contractorsWithSavedBasket.length > 0 && <div className='contractors-circle-navbar'>
                            {contractorsWithSavedBasket.length}
                        </div>}
                        {showContractors && <div className={contractorSelectorStyle}>
                            <div className="row mb-2">
                                <div className="col-4">
                                    <b className='me-3'>Nazwa</b>
                                </div>
                                <div className="col-2">
                                    <div className='d-flex flex-column'>
                                        <b className='me-3'>Nip</b>
                                        <b className='me-3'>Numer</b>
                                    </div>
                                </div>
                                <div className="col-2">
                                    <b className='me-3'>Data</b>
                                </div>
                                <div className="col-4">
                                    <b>Adres</b>
                                </div>
                            </div>
                            {contractorsWithSavedBasket && contractorsWithSavedBasket.length > 0 &&
                                contractorsWithSavedBasket.map((c, key) => {
                                    return (<div className='row notification-information-element-item mb-2' key={c.custId} onClick={() => { handleCustomerChange(c) }}>
                                        <div className="col-4">
                                            <b className='me-3'>{c.name}</b>
                                        </div>
                                        <div className="col-2">
                                            <div className='d-flex flex-column'>
                                                <b className='me-3'>{c.nip}</b>
                                                <span className='me-3'>{c.custNumber}</span>
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <span className='me-3'>{getLastAddedProductInBasketDate(c.lastAddedProductInBasketDate)}</span>
                                        </div>
                                        <div className="col-4">
                                            <span>{c.address}</span>
                                        </div>
                                    </div>)
                                })}
                        </div>}
                    </div>
                </div>
            )
        }
    }

    const handleBackToOfferClick = (mode) => {
        navigate(`/OfferRequest/${mode}/true/${editOfferRequestOfferNo}`)
        setEditOfferRequestOfferNo(null)
    }

    const handleBackToSavedBasket = () => {
        navigate('/SavedBaskets', { state: { params: { selectedTab: 'savedBasket' } } })
        setSelectedSavedBasket(null)
    }

    //PRODUCT
    const handleProductRedirect = (index, isAvailabilityLevelAdditionalInfoShowed, activeCategory) => {
        if (authState.user) {
            addProductToLastWatched(index)
        }
        if (!isAvailabilityLevelAdditionalInfoShowed) {
            navigate(`/product/${index}`, { state: { params: { prevCategory: activeCategory } } })
        }
    }

    const getCartIconColor = (quantityInCart, quantity) => {
        if (quantityInCart > 0) {
            if (Number(quantityInCart) != Number(quantity)) {
                return 'var(--primary)'
            }
            else {
                return 'white'
            }
        }
        else {
            return 'var(--primary)'
        }
    }

    const generateCartIcon = (size, quantityInCart, quantity) => {
        if (savedOfferId && savedOfferId != -1) {
            return <MdOutlineLocalOffer style={{ color: getCartIconColor(quantityInCart, quantity) }} size={size} />
        }
        else if (selectedSavedBasket) {
            return <TbShoppingCartPlus size={size} style={{ color: getCartIconColor(quantityInCart, quantity) }} />
        }
        else {
            return <FiShoppingCart size={size} style={{ color: getCartIconColor(quantityInCart, quantity) }} />
        }
    }

    const getCartIconBackgroundColor = (quantityInCart, quantity) => {
        if (quantityInCart > 0) {
            if (Number(quantityInCart) != Number(quantity)) {
                return 'white'
            }
            else {
                return 'var(--primary)'
            }
        }
        else {
            return 'white'
        }
    }

    /**
     * DK : Funkcja sprawdza czy produkt może zostać dodany do koszyka w wybranej ilości. Blokada na produkty wycofane
     * @param {*} qty qty dodawana do koszyka
     * @param {*} product produkt
     * @returns true / false czy może zostać dodany + wyświetla toast
     */
    const checkIfProductCanBeAddedWithQuantity = (qty, product) => {
        if (product.status == 2) {
            if (Number(qty) > Number(product.availabilityLevelInOtherWarehouses.qtyInAllWarehauses)) {
                toast.warning(`Produkt nie jest dostępny w większej ilości niż: ${product.availabilityLevelInOtherWarehouses.qtyInAllWarehauses} ${product.baseUnit.toLowerCase()}. Proszę o skorygowanie ilości do ilości dostępnej. W celu zamówienia większej 
                ilości skontaktuj się z opiekunem handlowym.`)
                return false
            }
        }
        return true
    }

    return {
        getLoadingDataSkeleton,
        getSocialMediaIcons,
        generateUserInformation,
        handleCategoryClick,
        handleSupplierClick,
        handleProductInQueryClick,
        getSumGross,
        handleProductRedirect,
        handleCopyToClipboard,
        NotificationSection,
        handleBackToOfferClick,
        checkIfProductCanBeAddedWithQuantity,
        getCartIconColor,
        getCartIconBackgroundColor,
        QuickContractorSelectorSection,
        handleBackToSavedBasket,
        generateCartIcon,
    }
}

export default useCommonFunctions